import { render, staticRenderFns } from "./media_player.vue?vue&type=template&id=0b3e8bf8"
import script from "./media_player.vue?vue&type=script&lang=js"
export * from "./media_player.vue?vue&type=script&lang=js"
import style0 from "./media_player.vue?vue&type=style&index=0&id=0b3e8bf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports